"use strict";

exports.__esModule = true;

exports.default = function (obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-devtools-dock-monitor/~/babel-runtime/helpers/interopRequireDefault.js
 ** module id = 291
 ** module chunks = 0
 **/